<!-- 平台管理 - 我的任务Excel管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部Excel文件</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="taskExcelQueryForm" :model="taskExcelQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="6" :offset="6">
                                    <el-form-item prop="serviceName">
                                        <el-input v-model="taskExcelQueryForm.excelFileName" :maxlength="100" placeholder="文件名称"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button @click="resetTaskExcelQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button type="primary" @click="queryTaskExcelList(1000)" icon="fas fa-search">查 询</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button type="primary" size="small" icon="fas fa-plus-circle" @click="openTaskExcelEditDialog('add')">添加Excel文件</el-button>
                    </div>
                    <div class="el-search-list">
                        <el-table ref="taskExcelTable" v-loading="taskExcelQueryLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: taskExcelQueryLoading}" :data="taskExcelList" :default-sort="taskExcelQuerySort" @sort-change="onTaskExcelQuerySortChange" style="width:100%;" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                            <el-table-column label="#" type="index" width="50"></el-table-column>
                            <el-table-column label="文件名称" prop="excelFileName" width="250" sortable></el-table-column>
                            <el-table-column label="文件路径" prop="excelFilePath" sortable></el-table-column>
                            <el-table-column label="上传人" prop="createBy" width="160" align="center" sortable>
                                <template slot-scope="scope">
                                    <span>{{scope.row.createByName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="上传时间" prop="createTime" width="100" align="center" sortable></el-table-column>
                            <el-table-column label="操作" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="deleteTaskExcel(scope.row)">删除文件</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination background v-show="showTaskExcelQueryPager" @current-change="onTaskExcelQueryCurrentPageChange" :current-page.sync="taskExcelQueryForm.currentPage" :page-size="taskExcelQueryForm.pageSize" layout="slot, prev, pager, next, total" :total="taskExcelQueryTotal">
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button :class="{active: taskExcelQueryForm.pageSize == 10}" @click="onTaskExcelQueryPageSizeChange(10);">10</el-button>
                                    <el-button :class="{active: taskExcelQueryForm.pageSize == 20}" @click="onTaskExcelQueryPageSizeChange(20);">20</el-button>
                                    <el-button :class="{active: taskExcelQueryForm.pageSize == 50}" @click="onTaskExcelQueryPageSizeChange(50);">50</el-button>
                                    <el-button :class="{active: taskExcelQueryForm.pageSize == 100}" @click="onTaskExcelQueryPageSizeChange(100);">100</el-button>
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer size="70%" :visible.sync="taskExcelEditDialogVisible" @closed="closeTaskExcelEditDialog">
                        <span slot="title" class="el-drawer-title"> 添加Excel文件</span>
                        <div class="el-drawer-content">
                            <el-form class="el-drawer-content-body" ref="taskExcelEditForm" :model="taskExcelEditForm" :rules="taskExcelEditRules" label-width="300px">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="上传EXCEL文件" prop="excelFilePath">
                                            <el-col :span="12">
                                                <el-upload class="upload-excel" ref="taskExcelUploader" name="uploadFile" :multiple="false" :limit="1" :on-exceed="handleUploadExcelExceed" :headers="uploadHeaders" :action="taskExcelUploadUrl" :data="taskExcelUploadParam" :before-upload="beforeTaskExcelUpload" :on-remove="handleTaskExcelRemove" :on-success="handleTaskExcelUploadSuccess" :on-error="handleUploadError">
                                                    <el-button slot="trigger" size="small" type="primary" icon="fas fa-plus-circle">选择文件</el-button>
                                                    <div class="el-upload__tip" slot="tip">只能上传xls|xlsx格式的EXCEL文件，大小不超过1MB!</div>
                                                </el-upload>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="文件名称" prop="excelFileName">
                                            <el-col :span="12">
                                                <el-input v-model="taskExcelEditForm.excelFileName" :maxlength="150"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeTaskExcelEditDialog">取 消</el-button>
                                <el-button type="primary" icon="far fa-save" @click="saveTaskExcel" :loading="submiting">确 定</el-button>
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

const EXCEL_TYPES = ['xls', 'xlsx'];

export default {
    name: 'TaskExcel',
    data() {
        return {
            submiting: false,
            taskExcelList: [],
            taskExcelQueryLoading: false,
            taskExcelQuering: false,
            taskExcelQueryForm: {
                excelFileName: '',
                pageSize: 10,
                currentPage: 1
            },
            taskExcelQueryTotal: 0,
            taskExcelQuerySort: {
                prop: 'createTime',
                order: 'descending'
            },
            currentActionType: 'add',
            taskExcelEditDialogVisible: false,
            taskExcelEditForm: {
                excelFileName: '',
                excelFilePath: ''
            },
            taskExcelEditRules: {
                excelFileName: [
                    {
                        required: true,
                        message: '请输入文件名称!'
                    }
                ],
                excelFilePath: [
                    {
                        required: true,
                        message: '请上传Excel文件!'
                    }
                ]
            },
            taskExcelUploadUrl: PLATFORM_API.of('/api/xupload/protected/file'),
            taskExcelUploadParam: {
                renameStrategy: 'ORIGINAL_FILENAME_AND_TIMESTAMP',
                formatLimit: EXCEL_TYPES.join(',')
            }
        };
    },
    computed: {
        showTaskExcelQueryPager() {
            if (this.taskExcelQuering || this.taskExcelQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json'
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        }
    },
    created() {},
    mounted() {
        this.queryTaskExcelList(1000);
    },
    methods: {
        queryTaskExcelList(loading) {
            this.taskExcelQueryForm.currentPage = 1;
            this.doQueryTaskExcelList(loading);
        },
        doQueryTaskExcelList(loading) {
            this.taskExcelQuering = true;
            if (loading) {
                this.taskExcelQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.taskExcelQueryForm,
                    mapSort(this.taskExcelQuerySort)
                );
                this.$http
                    .get(PLATFORM_API.of('/api/platform/visp/taskexcel/list'), {
                        params: params
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.taskExcelList = result.data;
                            this.taskExcelQueryTotal = result.totalRowCount;
                        } else {
                            this.taskExcelList = [];
                            this.taskExcelQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.taskExcelList = [];
                        this.taskExcelQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.taskExcelQueryLoading = false;
                        }
                        this.taskExcelQuering = false;
                    });
            }, loading);
        },
        resetTaskExcelQueryForm() {
            this.$refs.taskExcelQueryForm.resetFields();
        },
        onTaskExcelQuerySortChange(parameter) {
            if (
                this.taskExcelQuerySort.prop != parameter.prop ||
                this.taskExcelQuerySort.order != parameter.order
            ) {
                this.taskExcelQuerySort.prop = parameter.prop;
                this.taskExcelQuerySort.order = parameter.order;
                this.queryTaskExcelList(1000);
            }
        },
        onTaskExcelQueryPageSizeChange(pageSize) {
            this.taskExcelQueryForm.pageSize = pageSize;
            this.queryTaskExcelList(1000);
        },
        onTaskExcelQueryCurrentPageChange(currentPage) {
            this.taskExcelQueryForm.currentPage = currentPage;
            this.doQueryTaskExcelList(1000);
        },
        openTaskExcelEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.taskExcelEditDialogVisible = true;
        },
        closeTaskExcelEditDialog() {
            this.submiting = false;
            this.taskExcelEditDialogVisible = false;
            this.$refs.taskExcelEditForm.resetFields();
            this.$refs.taskExcelUploader.clearFiles();
            //手动reset
            this.taskExcelEditForm.excelFileId = '';
        },
        deleteTaskExcel(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/taskexcel/delete/' + row.excelFileId
            );
            this.$confirm('您确定要删除该服文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .delete(url)
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryTaskExcelList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
        saveTaskExcel() {
            let url = PLATFORM_API.of('/api/platform/visp/taskexcel/create');
            if (url) {
                this.$refs.taskExcelEditForm.validate(valid => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .post(url, this.taskExcelEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeTaskExcelEditDialog();
                                        this.$message.success(result.message);
                                        this.queryTaskExcelList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        beforeTaskExcelUpload(file) {
            let fileName = file.name;
            if (fileName.replace(/\s+/g, '') != fileName) {
                this.$message.error('上传文件名不能包含空格!');
                return false;
            }
            let fileType = fileName
                .substring(fileName.lastIndexOf('.') + 1)
                .toLowerCase();
            if (EXCEL_TYPES.indexOf(fileType) == -1) {
                this.$message.error(
                    '上传文件只能是EXCEL(xls、xlsx)格式的文件!'
                );
                return false;
            }
            if (file.size > 0 && file.size / 1024 / 1024 > 1) {
                this.$message.error('上传EXCEL文件大小不能超过1MB!');
                return false;
            }
            return true;
        },
        handleUploadExcelExceed(file, fileList) {
            this.$message.error('最多只能上传一个文件!若要重新上传请先删除.');
            return false;
        },
        handleTaskExcelUploadSuccess(response, file, fileList) {
            file.path = response.data.path;
            this.taskExcelEditForm.excelFileName = response.data.name;
            this.taskExcelEditForm.excelFilePath = response.data.path;
            this.$refs.taskExcelEditForm.validateField('excelFilePath');
        },
        handleTaskExcelRemove(file, fileList) {
            this.taskExcelEditForm.excelFileName = '';
            this.taskExcelEditForm.excelFilePath = '';
            try {
                if (file && file.path) {
                    this.$http.get(
                        PLATFORM_API.of(
                            '/api/xupload/protected/remove?path=' + file.path
                        )
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        }
    }
};
</script>